/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { isKnownDbCongruenceError } from "./lib/known-issues";
import "./index.css";

// See page-persist.ts's addPageFromBlob comment: a known, benign
// @tanstack/db bug throws this on every rapid same-key optimistic write.
// Suppress only this exact message so a real unhandled rejection still
// surfaces normally.
window.addEventListener("unhandledrejection", event => {
  if (!isKnownDbCongruenceError(event.reason)) return;
  event.preventDefault();
  console.debug("[known-issue] suppressed @tanstack/db row-congruence error (TanStack/db#1767, #1783)");
});

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
